import React, { useEffect, useState } from 'react'
import '@innovatrics/dot-face-auto-capture'
import type {
  FaceCallback,
  FaceCameraProps,
  FaceComponentData,
  HTMLFaceCaptureElement
} from '@innovatrics/dot-face-auto-capture'
import styles from '../styles/index.module.css'
import buttonStyles from '../styles/button.module.css'

interface Props {
  onPhotoTaken: FaceCallback
  onError: (error: Error) => void
}

/*
 * When component is initiliazed, sam.wasm file will be fetched from http://localhost:3000/sam.wasm.
 * That's why sam.wasm file need to be placed in root of public folder.
 */

const FaceCamera = (props: FaceCameraProps) => {
  useEffect(() => {
    // 2. Init existed custom web-component
    const faceAutoCaptureHTMLElement = document.getElementById(
      'x-dot-face-auto-capture'
    ) as HTMLFaceCaptureElement | null

    if (faceAutoCaptureHTMLElement) {
      faceAutoCaptureHTMLElement.cameraOptions = {
        ...props,
        thresholds: {
          brightnessLowThreshold: 100,
          faceConfidence: 0.1,
          sharpnessThreshold: 500
        },
        uiCustomisation: {
          // placeholder: {
          //   facePlaceholder: 'man-solid'
          // },
          instructions: {
            candidate_selection: 'Agora sim! Espera um pouco...',
            face_too_close: 'Rosto muito perto',
            face_too_far: 'Rosto muito longe',
            face_centering: 'Mais para o meio',
            face_not_present: 'Não vejo seu rosto',
            sharpness_too_low: 'Precisa de mais iluminação',
            brightness_too_low: 'Ambiente muito escuro!',
            brightness_too_high: 'Tem muita luz!'
          },

          colors: {
            placeholderColor: '#ffffff',
            instructionTextColor: '#1a89c9'
          },
          appStateInstructions: {
            loading: {
              text: 'Carregando...',
              visible: false
            },
            waiting: {
              visible: false
            }
          }
        }
      }
    }
  })

  // 1. Return empty custom web-component html TAG
  return <x-dot-face-auto-capture id="x-dot-face-auto-capture" />
}

const FaceAutoCapture = ({ onPhotoTaken, onError }: Props) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)

  const handlePhotoTaken = (image: Blob, data: FaceComponentData) => {
    setIsButtonDisabled(false)
    onPhotoTaken(image, data)
  }

  const handleContinueDetection = () => {
    document.dispatchEvent(
      new CustomEvent('face-auto-capture', {
        detail: { instruction: 'continue-detection' }
      })
    )

    setIsButtonDisabled(true)
  }
  return (
    <div className={styles.container}>
      {isButtonDisabled ? (
        <FaceCamera
          imageType="jpeg"
          cameraFacing="user"
          photoTakenCb={handlePhotoTaken}
          onError={onError}
        />
      ) : (
        ''
      )}
    </div>
  )
}

export default FaceAutoCapture
